export default __webpack_public_path__ + "media/images/features/ambassador/profiles/kururi_san-28d7a09471cda7433e37f1647b3005ce.jpg";